import { render, staticRenderFns } from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=template&id=0c96851e&"
import script from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=script&lang=js&"
export * from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./MetadadosCampoDinamicoListaCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCheckbox,VList,VListGroup,VListItem,VListItemAction,VListItemContent,VListItemTitle})
